import { mapState } from 'vuex'

import { logo, authTitle } from '@/constants/partnerBranding'
import fieldManagement from '@/constants/loginFieldObject'

import { getDeviceForPing } from '@/functions/device'
import { apiJoinGroup, getGroup } from '@/services/groups'
import { apiCreateUser } from '@/services/users'
import { apiUserLogin } from '@/services/endpoints/session'

import confirmDialogMixin from '@/mixins/cd.mixin.js'
import { isValidEmail } from '@/mixins/regex.mixin'

import SosButton from '@/components/SosButton'
import SosLoginField from '@/components/SosLoginField'

import ConfirmDialog from '@/modals/ConfirmDialog'
import ModalTermsOfUse from '@/modals/ModalTermsOfUse'
import PasswordRecoveryModal from '@/modals/PasswordRecoveryModal'

//
//
//
// Component
//
//
//

export default {
  name: 'JoinGroup',

  mixins: [
    confirmDialogMixin,
  ],

  components: {
    'sos-button': SosButton,
    'sos-login-field': SosLoginField,

    'confirm-dialog': ConfirmDialog,
    'modal-terms-of-use': ModalTermsOfUse,
    'password-recovery-modal': PasswordRecoveryModal,
  },

  data: () => ({
    status: 'WAITING',

    loadedGroup: null,

    isJoiningGroup: false,

    //
    //
    //

    tab: 0,

    logo,
    authTitle,

    //
    //
    //

    // SIGN IN FORM

    loadingSignIn: false,

    loginEmail: { ...fieldManagement, value: '' },
    loginPassword: { ...fieldManagement, value: '', hidden: true },

    // SIGN UP FORM

    loadingSignUp: false,

    nameSignUp: { ...fieldManagement, value: '' },
    telephoneSignUp: { ...fieldManagement, value: '' },
    emailSignUp: { ...fieldManagement, value: '' },
    emailConfirmationSignUp: { ...fieldManagement, value: '' },
    passwordSignUp: { ...fieldManagement, value: '' },
    passwordConfirmationSignUp: { ...fieldManagement, value: '' },
  }),

  computed: {
    ...mapState({
      userSession: state => state.app.userSession,
    }),
  },

  watch: {
    //
    //
    //

    userSession: {
      immediate: true,
      deep: true,
      handler (dataNew, _)
      {
        this.load('WATCH', dataNew)
      },
    },
  },

  created ()
  {
    if (!!this.$route.params.groupID === false || !!this.$route.params.invitationCode === false)
    {
      this.$router.push('404')
    }
  },

  mounted ()
  {
    this.load('MOUNTED', this.userSession)
  },

  methods: {
    //
    //
    //
    // ?
    //
    //
    //

    async load (origin, userSession)
    {
      // console.log('::: [DEBUG] LOAD:', origin, userSession.authState)

      if (
        !!userSession === true &&
        userSession.hasOwnProperty('authState') &&
        userSession.authState === 'DONE' &&
        this.status !== 'LOADING'
      )
      {
        const userId = String(!!userSession.loggedIn === true ? userSession.uid : '')

        //
        // LOAD GROUP
        //

        this.status = 'LOADING'

        const loadedGroup = await getGroup(this.$route.params.groupID)

        const group = !!loadedGroup === true && loadedGroup.hasOwnProperty('idconvite') ? loadedGroup : null

        if (!!group === false)
        {
          this.status = 'INVALID_GROUP'
        }
        else if (group.idconvite !== this.$route.params.invitationCode)
        {
          this.status = 'INVALID_INVITATION_CODE'
        }
        else
        {
          this.loadedGroup = { groupID: this.$route.params.groupID, ...group }

          if (!!userId === false) {
            this.status = 'NOT_AUTHENTICATED'
          } else {
            this.status = !!group.users === true && !!group.users[userId] === true ? 'GROUP_MEMBER' : 'NOT_A_MEMBER'
          }
        }

        // console.log('::: WATCH > userSession:', userSession, userId, this.loadedGroup)
      }
    },

    //
    //
    //
    // ?
    //
    //
    //

    //
    //
    //

    clearLoginEmail () {
      this.loginEmail.value = ''
    },

    clearLoginPassword () {
      this.loginPassword.value = ''
    },

    switchLoginPasswordMode () {
      this.loginPassword.hidden = !this.loginPassword.hidden
    },

    //
    //
    //

    clearRegisterName () {
      this.nameSignUp.value = ''
    },

    clearRegisterPhone () {
      this.telephoneSignUp.value = ''
    },

    clearRegisterEmail () {
      this.emailSignUp.value = ''
    },

    clearRegisterEmailConfirmation () {
      this.emailConfirmationSignUp.value = ''
    },

    clearRegisterPassword () {
      this.passwordSignUp.value = ''
    },

    clearRegisterPasswordConfirmation () {
      this.passwordConfirmationSignUp.value = ''
    },

    //
    //
    //
    // OPEN PASSWORD RECOVERY MODAL
    //
    //
    //

    openRecoveryWindow () {
      this.$refs.recoveryModal.open(this.loginEmail.value)
    },

    //
    //
    //
    // OPEN TERMS MODAL
    //
    //
    //

    openTermsModal () {
      this.$refs.termsModal.open()
    },

    //
    //
    //
    // SIGN IN FORM
    //
    //
    //

    async signIn ()
    {
      // CLEAN FIELDS STATUSES

      this.loginEmail.setError('')
      this.loginPassword.setError('')

      // VALIDATE

      const emailField = this.loginEmail.value.trim()
      const passwordField = this.loginPassword.value

      if (!isValidEmail(emailField)) {
        this.loginEmail.setError('Informe um e-mail válido.')
        this.$nextTick(() => { this.$refs.loginEmail.triggerBounce() })
      }

      if (passwordField.length < 6) {
        this.loginPassword.setError('Informe no mínimo 6 caracteres para a senha.')
        this.$nextTick(() => { this.$refs.loginPassword.triggerBounce() })
      }

      if (this.loginEmail.error || this.loginPassword.error)
      {
        if (this.loginEmail.error) {
          this.$refs.loginEmail.onFocus()
        } else if (this.loginPassword.error) {
          this.$refs.loginPassword.onFocus()
        }

        return false
      }

      // RUN

      this.loadingSignIn = true

      const device = await getDeviceForPing()
      const response = await apiUserLogin(device, emailField, passwordField)

      if (response.httpCode !== 200)
      {
        this.loadingSignIn = false

        const target = String(response?.data?.target || '').trim()

        if (target === 'PASSWORD') {
          this.loginPassword.setError(response.message)
        } else if (target === 'EMAIL') {
          this.loginEmail.setError(response.message)
        } else {
          this.loginEmail.setError('')
          this.loginPassword.setError('')
        }

        this.showDialog(response.title, response.message, 'signin', target, true, 'right', 330, true)
      }
    },

    //
    //
    //
    // SIGN UP FORM
    //
    //
    //

    async signUp ()
    {
      // CLEAN FIELDS STATUSES

      this.nameSignUp.setError('')
      this.telephoneSignUp.setError('')
      this.emailSignUp.setError('')
      this.emailConfirmationSignUp.setError('')
      this.passwordSignUp.setError('')
      this.passwordConfirmationSignUp.setError('')

      // VALIDATE

      const nome = this.nameSignUp.value.trim()
      const telefone = this.telephoneSignUp.value.replace(/[^0-9]/g, '')
      const email = this.emailSignUp.value.trim()
      const emailConfirmation = this.emailConfirmationSignUp.value.trim()
      const password = this.passwordSignUp.value.trim()
      const passwordConfirmation = this.passwordConfirmationSignUp.value.trim()

      if (nome.length < 3 || nome.length > 64) {
        this.nameSignUp.setError('Digite entre 3 e 64 caracteres')
        this.$nextTick(() => { this.$refs.nameSignUp.triggerBounce() })
      }

      if (telefone.length < 10 || telefone.length > 11) {
        this.telephoneSignUp.setError('Digite um número nos formatos: (99) 91234-5678 ou (99) 1234-5678')
        this.$nextTick(() => { this.$refs.telephoneSignUp.triggerBounce() })
      }

      if (!isValidEmail(email)) {
        this.emailSignUp.setError('E-mail inválido')
        this.$nextTick(() => { this.$refs.emailSignUp.triggerBounce() })
      }

      if (email !== emailConfirmation) {
        this.emailConfirmationSignUp.setError('E-mail e confirmação de e-mail não conferem')
        this.$nextTick(() => { this.$refs.emailConfirmationSignUp.triggerBounce() })
      }

      if (password.length < 8 || password.length > 20 || password.search(/\d/) === -1 || password.search(/[a-zA-Z]/) === -1) {
        this.passwordSignUp.setError('Digite entre 8 e 20 caracteres contendo letras e números')
        this.$nextTick(() => { this.$refs.passwordSignUp.triggerBounce() })
      }

      if (passwordConfirmation !== password) {
        this.passwordConfirmationSignUp.setError('Senha e confirmação de senha não conferem')
        this.$nextTick(() => { this.$refs.passwordConfirmationSignUp.triggerBounce() })
      }

      if (
        this.nameSignUp.error ||
        this.telephoneSignUp.error ||
        this.emailSignUp.error ||
        this.emailConfirmationSignUp.error ||
        this.passwordSignUp.error ||
        this.passwordConfirmationSignUp.error
      ) {
        if (this.nameSignUp.error) {
          this.$refs.nameSignUp.onFocus()
        } else if (this.telephoneSignUp.error) {
          this.$refs.telephoneSignUp.onFocus()
        } else if (this.emailSignUp.error) {
          this.$refs.emailSignUp.onFocus()
        } else if (this.emailConfirmationSignUp.error) {
          this.$refs.emailConfirmationSignUp.onFocus()
        } else if (this.passwordSignUp.error) {
          this.$refs.passwordSignUp.onFocus()
        } else if (this.passwordConfirmationSignUp.error) {
          this.$refs.passwordConfirmationSignUp.onFocus()
        }

        return false
      }

      // RUN

      this.loadingSignUp = true
      const request = await apiCreateUser({ origin: 'WEB', name: nome, email, password, phone: telefone, crm: '', groupID: this.$route.params.groupID })
      this.loadingSignUp = false

      // SHOW BACK-END RESPONSE
      this.showMessage(request.title, request.message)

      // REGISTER WAS SUCCESSFULL
      if (request.httpCode === 201)
      {
        // ENTRAR NO FORMULÁRIO DE ACESSO
        this.tab = 0

        // INCLUIR E-MAIL E SENHA RECÉM CRIADOS NO FORMULÁRIO DE ACESSO
        this.loginEmail.value = email
        this.loginPassword.value = password

        this.loginEmail.setError('')
        this.loginPassword.setError('')

        // JESUS: Aplicar alguma mudança na tela e na mensagem de VOCÊ FOI CONVIDADO após o cadastro bem sucedido?
        // this.status ===
      }
    },

    //
    //
    //
    // JOIN GROUP
    //
    //
    //

    async joinGroup ()
    {
      if (!!this.userSession === true && !!this.userSession.uid === true)
      {
        this.isJoiningGroup = true
        const response = await apiJoinGroup(this.userSession.uid, this.$route.params.groupID)
        this.isJoiningGroup = false

        if (response.code === 0) {
          this.showMessage('Erro!', response.message)
        } else {
          this.status = 'JOINED_GROUP'
        }
      }
      else
      {
        // ERROR JOINING / NOT LOGGED IN
        this.showMessage('Erro!', 'Não foi possível aceitar o convite porque você não entrou na sua conta!')
      }
    },

    cdAction (cdResponse)
    {
      // console.log('::: cdAction:', cdResponse)

      if (cdResponse.cdType === 'signin')
      {
        if (cdResponse.cdData === 'PASSWORD') {
          this.$nextTick(() => { this.$refs.loginPassword.onFocus() })
        } else {
          this.$nextTick(() => { this.$refs.loginEmail.onFocus() })
        }
      }
    },
  },

  head: {
    // creates a title tag in header.
    title () {
      return {
        inner: 'Convite para Grupo',
      }
    },
    meta: [
      { name: 'description', content: 'Convite para Grupo', id: 'desc' }, // id to replace intead of create element
      // ...
      // Twitter
      { name: 'twitter:title', content: 'Convite para Grupo' },
      // with shorthand
      { n: 'twitter:description', c: 'Convite para Grupo' },
      // ...
      // Google+ / Schema.org
      { itemprop: 'name', content: 'Convite para Grupo' },
      { itemprop: 'description', content: 'Convite para Grupo' },
      // ...
      // Facebook / Open Graph
      { property: 'og:title', content: 'Convite para Grupo' },
      // ...
    ],
  },
}
